<template>
  <div class="componentBox">
    <h2 class="componentTitle">客户反馈</h2>
    <Cell :colList="list" :detail="poultryLineFeedback" :len="1" />
    <div class="cellBox">
      <span class="cellTitle">图片：</span>
      <div>
        <img v-for="(img,i) in imageValue" :key="i" width="200" :src="img.url" alt="" @click="()=>handlePreview(img)" />
      </div>
    </div>
    <div class="cellBox">
      <span class="cellTitle">视频：</span>
      <div>
        <video v-for="vdo in videoValue" :key="vdo.url" :src="vdo.url" alt=""  @click="()=>handlePreview0(vdo)"  style="width: 200px;height: 200px"/>
      </div>
    </div>
    <div class="cellBox">
      <span class="cellTitle">其他意见</span>
      <div>
        {{detail.remark}}
      </div>
    </div>
    <a-modal :visible="previewVisible" :title="previewTitle" :bodyStyle="{ height: '500px',textAlign: 'center',alignItems: 'center',display: 'flex' }" :footer="null" @cancel="handleCancel">
      <img alt="example" style="max-height: 100%;max-width: 100%" :src="previewImage" />
    </a-modal>
    <a-modal :visible="previewVisible0" :title="previewTitle" :bodyStyle="{ height: '500px',textAlign: 'center',alignItems: 'center',display: 'flex' }" :footer="null" @cancel="handleCancel">
      <video alt="example" style="max-height: 100%;max-width: 100%;"  :src="previewVideo" controls/>
    </a-modal>
  </div>
</template>

<script>
import Cell from './Cell.vue';
import api from '../api'
export default {
  components: {Cell},
  props: ['detail','detailUpload'],
  data() {
    return {
      list: [
        {title: '粪便',field: 'shit',},
        {title: '蛋壳颜色',field: 'eggshellColor',},
        {title: '客户满意度（分）',field: 'customerSatisfaction',},
      ],
      imageValue: [],
      videoValue: [],
      
      previewImage: '',
      previewVideo: '',
      previewVisible: false,
      previewVisible0: false,
      previewTitle: '',
    }
  },
  watch: {
    detail:{
      handler(){
        this.dealFiles()
      },
      deep: true,
    }
  },
  computed: {
    poultryLineFeedback() {
      let obj = {...this.detail}
      let {shit,eggshellColor} = obj || {}
      if(eggshellColor == 1){
        obj.eggshellColor = '正常'
      } else {
        obj.eggshellColor = '偏白'
      }
      if(shit == 1){
        obj.shit = '正常'
      } else {
        obj.shit = '偏湿'
      }
      return obj
    },
  },
  created() {},
  mounted() {},
  methods: {
    handleCancel(){
      this.previewVisible = false
      this.previewVisible0 = false
      this.previewTitle = ''
      this.previewImage = ''
      this.previewVideo = ''
    },
    async handlePreview(file) {
      this.previewImage = file.url;
      this.previewVisible = true;
      this.previewTitle = file.fileName || file.url.substring(file.url.lastIndexOf('/') + 1);
    },
    async handlePreview0(file) {
      this.previewVideo = file.url;
      this.previewVisible0 = true;
      this.previewTitle = file.fileName || file.url.substring(file.url.lastIndexOf('/') + 1);
    },
    dealFiles(){
      let {uploadFiles=[]} = this.detailUpload || {}
      uploadFiles.forEach(v => {
        this.imageValue = []
        this.videoValue = []
        if (v.mediaType == 'PIC') {
          api.getFileUrlList({fileName: v.fileName}).then(res => {
            this.imageValue.push({
              ...v,
              name: v.picLink,
              url: res.data
            })
          })
        } else {
          api.getFileUrlList({fileName: v.fileName}).then(res => {
            this.videoValue.push({
              ...v,
              name: v.picLink,
              url: res.data
            })
          })
        }
      })
    },
  },
}
</script>
<style lang='scss'></style>
<style lang='scss' scoped></style>